// import React from "react";
// import RoleToggle from "./RoleToggle";
// import { TabConfig } from "../hooks/usePermissionTabs";

// interface Props {
//     title?: string;
//     visibleTabs: TabConfig[];
//     activeLabel: string;
//     content: React.ReactNode;
//     isLoading: boolean;
//     error: any;
//     handleChange: (label: string) => void;
//     className?: string;
//     loadingHeight?: string;
// }

// export const PermissionTabManager: React.FC<Props> = ({
//     title,
//     visibleTabs,
//     activeLabel,
//     content,
//     isLoading,
//     error,
//     handleChange,
//     className = "px-6 space-y-4",
//     loadingHeight = "h-64",
// }) => {
//     if (isLoading) {
//         return (
//             <div className={className}>
//                 {title && (
//                     <div className="flex justify-between items-center">
//                         <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">{title}</h1>
//                         <div className="w-64 h-10 bg-gray-200 rounded animate-pulse" />
//                     </div>
//                 )}
//                 <div className="bg-white rounded-xl p-6">
//                     <div className={`${loadingHeight} bg-gray-100 rounded animate-pulse`} />
//                 </div>
//             </div>
//         );
//     }

//     // if (error || visibleTabs.length === 0) {
//     //     return (
//     //         <div className={className}>
//     //             {title && (
//     //                 <div className="flex justify-between items-center">
//     //                     <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">{title}</h1>
//     //                 </div>
//     //             )}
//     //             <div className="bg-white rounded-xl p-6 text-center text-gray-500">
//     //                 {error ? "Failed to load permissions." : "No access to any section."}
//     //             </div>
//     //         </div>
//     //     );
//     // }
//     if (!isLoading && (error || visibleTabs.length === 0)) {
//   return (
//     <div className={className}>
//       <div className="bg-white rounded-xl p-6 text-center text-gray-500">
//         {error ? "Failed to load permissions." : "No access to any section."}
//       </div>
//     </div>
//   );
// }


//     return (
//         <div className={className}>
//             <div className="flex justify-between items-center flex-wrap lg:flex-nowrap">
//                 {title && <h1 className="text-2xl text-[#212121] tracking-[-0.5px] mb-3 lg:mb-0">{title}</h1>}
//                 <RoleToggle
//                     options={visibleTabs.map((t) => t.label)}
//                     active={activeLabel}
//                     onChange={handleChange}
//                 />
//             </div>
//             <div className="">{content}</div>
//         </div>
//     );
// };

import React from "react";
import RoleToggle from "./RoleToggle";
import { TabConfig } from "../hooks/usePermissionTabs";

interface Props {
    title?: string;
    visibleTabs: TabConfig[];
    activeLabel: string;
    content: React.ReactNode;
    isLoading: boolean;
    permissionsReady: boolean;
    error: any;
    handleChange: (label: string) => void;
    className?: string;
    loadingHeight?: string;
}

export const PermissionTabManager: React.FC<Props> = ({
    title,
    visibleTabs,
    activeLabel,
    content,
    isLoading,
    permissionsReady,
    error,
    handleChange,
    className = "px-6 space-y-4",
    loadingHeight = "h-64",
}) => {
    // Still fetching profile or permissions — show a skeleton, never "no access".
    if (isLoading || !permissionsReady) {
        return (
            <div className={className}>
                {title && (
                    <div className="flex justify-between items-center">
                        <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">{title}</h1>
                        <div className="w-64 h-10 bg-gray-200 rounded animate-pulse" />
                    </div>
                )}
                <div className="bg-white rounded-xl p-6">
                    <div className={`${loadingHeight} bg-gray-100 rounded animate-pulse`} />
                </div>
            </div>
        );
    }

    // Permissions loaded — now it is safe to show "no access".
    if (error || visibleTabs.length === 0) {
        return (
            <div className={className}>
                <div className="bg-white rounded-xl p-6 text-center text-gray-500">
                    {error ? "Failed to load permissions." : "No access to any section."}
                </div>
            </div>
        );
    }

    return (
        <div className={className}>
            <div className="flex justify-between items-center flex-wrap lg:flex-nowrap">
                {title && <h1 className="text-2xl text-[#212121] tracking-[-0.5px] mb-3 lg:mb-0">{title}</h1>}
                <RoleToggle
                    options={visibleTabs.map((t) => t.label)}
                    active={activeLabel}
                    onChange={handleChange}
                />
            </div>
            <div className="">{content}</div>
        </div>
    );
};